import React from 'react';
import { Blackcurrant, Orange, Strawberry, Cola, Pineapple, Original, Peach, Watermelon, Apple, UpArrow } from '../icons/Icons';

const PageSix = (props) => {
  return (
    <div className="kids-quiz__page">
      <h1>Almost there...</h1>

      <div className="kids-quiz__question">
        <p className="question__title">What flavour would {props.kidsName} like on {props.gender === 'male' ? 'his' : props.gender === 'female' ? 'her' : 'their'} stacks?</p>
        <div className="radio-answers answers-row--3 wide">

          <input type="radio" name="flavour" id="flavourWatermelon" value="watermelon" onChange={props.selectFlavour} checked={props.flavour === 'watermelon'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--watermelon" htmlFor="flavourWatermelon"><Watermelon />Watermelon</label>

          {/* <input type="radio" name="flavour" id="flavourApple" value="apple" onChange={props.selectFlavour} checked={props.flavour === 'apple'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--apple" htmlFor="flavourApple"><Apple />Green Apple</label> */}

          <input type="radio" name="flavour" id="flavourPeach" value="peach" onChange={props.selectFlavour} checked={props.flavour === 'peach'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--peach" htmlFor="flavourPeach"><Peach />Peach</label>

          <input type="radio" name="flavour" id="flavourBlackcurrant" value="blackcurrant" onChange={props.selectFlavour} checked={props.flavour === 'blackcurrant'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--blackcurrant" htmlFor="flavourBlackcurrant"><Blackcurrant />Blackcurrant</label>

          <input type="radio" name="flavour" id="flavourOrange" value="orange" onChange={props.selectFlavour} checked={props.flavour === 'orange'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--orange" htmlFor="flavourOrange"><Orange />Orange</label>

          <input type="radio" name="flavour" id="flavourStrawberry" value="strawberry" onChange={props.selectFlavour} checked={props.flavour === 'strawberry'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--strawberry" htmlFor="flavourStrawberry"><Strawberry />Strawberry</label>

          <input type="radio" name="flavour" id="flavourPineapple" value="pineapple" onChange={props.selectFlavour} checked={props.flavour === 'pineapple'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--pineapple" htmlFor="flavourPineapple"><Pineapple />Pineapple</label>

          <input type="radio" name="flavour" id="flavourCola" value="cola" onChange={props.selectFlavour} checked={props.flavour === 'cola'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--cola" htmlFor="flavourCola"><Cola />Cola</label>

          <input type="radio" name="flavour" id="flavourOriginal" value="original" onChange={props.selectFlavour} checked={props.flavour === 'original'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--original" htmlFor="flavourOriginal"><Original />Original</label>
        </div>

        <div className={`line-divider ${props.flavour ? 'line-divider--show' : 'line-divider--hidden'}`}></div>

        <div className={`coating-answers radio-answers answers-row--2 kids-quiz__question ${props.flavour ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
          <input type="radio" name="coating" id="coatingSweet" value="sweet" onChange={props.selectCoating} checked={props.coating === 'sweet'} />
          <label className="answer-button" htmlFor="coatingSweet">Sweet</label>

          <input type="radio" name="coating" id="coatingSour" value="sour" onChange={props.selectCoating} checked={props.coating === 'sour'} />
          <label className="answer-button" htmlFor="coatingSour">Sour</label>
        </div>
      </div>

      <a href="#parentsName" className={`question-divider ${props.coating ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="parentsName" className={`kids-quiz__question ${props.coating ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label>What's your name?</label>
        <input onChange={e => props.updateParentsName(e.target.value)} placeholder="Parent's name" value={props.parentsName} />
      </div>

      <a href="#email" className={`question-divider ${props.parentsName ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="email" className={`kids-quiz__question ${props.parentsName ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label>And finally, what is your email address?</label>
        <input onChange={e => props.setEmail(e.target.value)} placeholder="Email address (optional)" value={props.email} />
        <div className="checkbox" onChange={() => props.setConsent(!props.consent)}>
          <input id="email" name="consent" className="checkbox__input" type="checkbox" value="email" />
          <label htmlFor="email" className="checkbox__label">I agree to receive personalised email communications from Nourished based on my answers in this quiz</label>
        </div>
      </div>

      <div className={`next-page ${props.parentsName ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('6')}>Continue</div>
    </div>
  );
}

export default PageSix;